/* eslint-disable react/no-danger */

import PropTypes from 'prop-types';
import React from 'react';
import { ITALIC_END, ITALIC_START } from '../../../constants/regExp';
import AnswerButtonContainer from '../AnswerButton/AnswerButtonContainer';
import ComprehensionStimulusContainer from '../AnswerButton/StimulusContainer';

const LCOneAnswerQuestionView = props => {
    const text = props.stimulus.text.replace(ITALIC_START, '<i>').replace(ITALIC_END, '</i>');

    const onSelectedAnswer = responseIndex => {
        return () => {
            props.onAnswerClick(responseIndex);
        };
    };

    const getAnswerOption = (answer, index) => {
        return (
            <AnswerButtonContainer
                text={answer.text}
                key={answer.id}
                index={index}
                isSelected={index === props.selectedIndex}
                onAnswerClick={onSelectedAnswer(index)}
                audio={answer.audio}
                isDisabled={props.isDisabled}
            />
        );
    };

    const getAnswers = () => {
        return (
            <div className="vertical-answer-buttons">
                {props.possibleResponses.map((response, index) => getAnswerOption(response, index))}
            </div>
        );
    };

    return (
        <div>
            <div className="comprehension-question">
                <div className={`${props.measure}-header`}>
                    <ComprehensionStimulusContainer audioTracks={[props.stimulus.audio]} />
                    <div className="header-text">
                        {/* TODO: replace below with react-markdown or manual replacement of text with elements */}
                        <p className="lc-text" dangerouslySetInnerHTML={{ __html: text }} />
                    </div>
                </div>
            </div>
            <div className="comprehension-answers">{getAnswers()}</div>
        </div>
    );
};

LCOneAnswerQuestionView.propTypes = {
    measure: PropTypes.string,
    stimulus: PropTypes.shape({ text: PropTypes.string, audio: PropTypes.string }),
    possibleResponses: PropTypes.array,
    selectedIndex: PropTypes.number,
    onAnswerClick: PropTypes.func,
    isDisabled: PropTypes.bool,
};

LCOneAnswerQuestionView.defaultProps = {
    measure: '',
    stimulus: {
        text: '',
        audio: '',
    },
    possibleResponses: [],
    selectedIndex: -1,
    onAnswerClick: () => {},
    isDisabled: false,
};

export default LCOneAnswerQuestionView;
